import React from 'react'
import CardTypeFinder from './CardTypeFinder'
import useWindowDimensions from '../../useWindowDimensions'

const Card = ({marginValue, clickCard, index, card, animatingCards = new Set()}) => {

    const isDraggable = (card) => {
        while (card.next !== null) {

            let next_value = +card.next.val.value - 1;
            let cur_value = +card.val.value;
            // check cards if in correct order
            if (next_value !== cur_value || card.val.show === false) {
                return false
            }

            card = card.next
        }
        return true
    }

    const { width:width2 } = useWindowDimensions();

    const id = card.val.value + " " + card.val.deck// calculate each cards spesific id
    const cardType = CardTypeFinder(card) // get correct image for card's value
    const isActive = card.val.active
    const isShow = card.val.show
    
    // Check if this card is animating by checking for any ID that starts with this card's ID
    const isAnimating = Array.from(animatingCards).some(animatingId => 
        animatingId.startsWith(id + "-" + index)
    )
    
    // Set column-specific CSS variables if this card is animating
    React.useEffect(() => {
        if (isAnimating) {
            const cardElement = document.getElementById(id);
            if (cardElement) {
                cardElement.style.setProperty('--current-deck-offset-x', `var(--deck-offset-x-${index})`);
                cardElement.style.setProperty('--current-deck-offset-y', `var(--deck-offset-y-${index})`);
            }
        }
    }, [isAnimating, id, index]);

    return (
        <div
            draggable={ isDraggable(card) }
            onDragStart={ clickCard(card,index) }
            onDrop={ clickCard(card,index) }
            onDragOver={ (e) => e.preventDefault() }
            id={id}
            className = {
                "card " + 
                (isActive ? 'selectedCard' : '') + 
                (isAnimating ? ' card-dealing' : '') // add animation class if card is being animated
            }
            onClick = { clickCard(card, index) }
            style={{
            marginTop: (marginValue * (width2 < 910 ? 15 : 25)),
                ...(isShow ? { // if card's show property true, display the card
                    background: (`var(${cardType})`),
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat'} : ""),
                    ...( width2 < 1150 ? {height: width2 > 910 ? 90 : 50,
                                        width: width2 > 910 ? 65 : 36} : "") }}  >
        </div>
    )
}

export default Card
